
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import PickerDate from '@/components/picker-date.vue';
  import Dialog from '@/components/dialog.vue';
  import delClass from './delClass.vue'
  import creatThird from './creatThird.vue'
  import {
    productproductThirdClassList,
  } from "@/api/order"
  @Component({  
    name: '',
    components: {
      PageFooter,
      PickerDate,
      'slz-dialog': Dialog,
      delClass,
      creatThird
    }
  })
  export default class ProductList extends Vue {
    private keywords = ''
    private tablelist:any = []
    private tableloading = false
    private pageNo = 1
    private pageSize = 20
    private total = 0
    private rowmsg:any = {}
    private delShow = false
    private creatThirdShow = false




    private mounted () {
      this.gettablelist()
    }



    editClass(row){
      this.rowmsg = {
        Id:row.Id||0,
        ClassName:row.ThirdClassName||'',
        Level:2,
        SecondClassName:row.SecondClassName||decodeURI(this.$route.query.Name as string),
        ParentId:this.$route.query.Id
      }
      this.creatThirdShow = true
    }
    private toDel(row){
      this.rowmsg = row
      this.delShow = true
    }
    private clearSearch(){
      this.keywords = ''
      this.doSearch()
    }
    private doSearch(){
      this.pageNo = 1
      this.gettablelist()
    }
    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let res:any = await productproductThirdClassList({
          ParentId:this.$route.query.Id,
          Keywords:this.keywords,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        })
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
  }
